<template>
  <div class="row">
    <div class="col-12 mx-0 px-0">
      <div class="intro">
        <h1 class="intro__headline">Dzięki!</h1>
        <div class="intro__content">
          Twoja walentynka czeka w Twojej skrzynce mailowej!
          <br />
          Znasz kogoś, kto też chciałby wysłać wilkom walentynkę? Udostępnij ją!
        </div>
        <ShareLinks />
      </div>
    </div>
  </div>
</template>

<script>
import ShareLinks from "@/components/ShareLinks.vue";
export default {
  name: "Intro",
  inject: ["content"],
  components: {
    ShareLinks,
  },
  data() {
    return {
      title: "Introduction",
    };
  },
  methods: {},
};
</script>
